import { useCallback, useState } from 'react';

import { Pagination } from '@/types/interfaces/pagination';

export const usePagination = (
  total?: number,
  initialPage: number = 1,
  initialPerPage: number = 10,
): Pagination => {
  const [page, setPage] = useState(initialPage);
  const [perPage, setPerPage] = useState(initialPerPage);
  const [totalItems, setTotalItems] = useState(total ?? 0);

  const totalPages = Math.ceil(totalItems / perPage);
  const prevDisabled = page <= 1;
  const nextDisabled = page >= totalPages;

  const prevPage = useCallback(() => {
    if (prevDisabled) {
      return;
    }

    setPage(prevPage => prevPage - 1);
  }, [prevDisabled]);

  const nextPage = useCallback(() => {
    if (nextDisabled) {
      return;
    }

    setPage(nextPage => nextPage + 1);
  }, [nextDisabled]);

  const changePerPage = useCallback((perPage: number) => {
    setPerPage(perPage);
    setPage(1);
  }, []);

  const changePage = useCallback(
    (newPage: number) => {
      if (newPage > 0 && newPage <= totalPages) {
        setPage(newPage);
      }
    },
    [totalPages],
  );

  return {
    page,
    perPage,
    totalPages,
    prevDisabled,
    nextDisabled,
    prevPage,
    nextPage,
    changePerPage,
    setTotalItems,
    changePage,
  };
};
